<template>
  <div>
    <div class="all-users-page test-class">
      <h1 class="page-header color-1-100">Categories in "Topics"</h1>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{ categories.length }} subcategories
          </div>
        </div>
        <a href="#"
           v-on:click.prevent="displayAddForm()"
           class="data-list-add"
           :class="[{ 'data-list-add__close': addFormDisplay}]"
           tabindex="-1">Add new category</a>
      </div>
      <div class="data-list-selected-filters" v-if="parent">
        <div class="data-list-selected-filters-applied">
          <span>Filters applied:<br/>{{ this.updatedCategories.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button
                  type="button"
                  @click="removeSelectedFilters"
                  @mouseover="addHoverElement([{label: parent.label, value: parent.value}])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(this.parent)}">
            <span>{{parent.label}}</span>
          </button>
          <span class="data-list-selected-filters-remove-all"
                @click="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
        </div>
      </div>
      <div class="categories-add-form" v-if="addFormDisplay">
        <div class="form-group form-group-half">
          <div class="form-element">
            <label for="input-category-name" class="form-label color-2-63">Category Name</label>
            <input type="text"
                   id="input-category-name"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newCategory.title"/>
          </div>
          <div class="form-element">
            <label for="input-category-icon" class="form-label color-2-63">Category Icon</label>
            <input type="text"
                   id="input-category-icon"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newCategory.icon"/>
          </div>
          <div class="form-element">
            <label for="select-parent-category" class="form-label color-2-63">Parent</label>
            <v-select
                    v-model="newCategory.parent"
                    name="Category"
                    class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                    :options="parentCategoriesForSelect"
                    id="select-parent-category"/>
          </div>
        </div>
        <div class="form-group form-group-half">
          <div class="form-element">
            <label for="textarea-category-desc" class="form-label color-2-63">Category description
              <span>(will not show up in articles)</span></label>
            <textarea
                    name="category-desc"
                    id="textarea-category-desc"
                    cols="30"
                    rows="5"
                    style="height: 140px;"
                    v-model="newCategory.description"
                    class="form-control form-control__textarea">
              </textarea>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="update-data update-data__details">
          <a href="#" v-on:click.prevent="closeAddForm()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Cancel</a>
          <a href="#" v-on:click.prevent="createCategory()" class="save-edit background-1-100 color-2-100 save-edit-details">Create category</a>
        </div>
        <hr class="add-form-delimiter" />
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead class="categories-list-body__head">
          <tr>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">ID</th>
            <th class="categories-list-search-col text-left categories-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchString"
                          type="search"
                          class="table-search"
                          placeholder="Category name..."/>
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="categories-list-body__head_parent-select table-head-ceil table-head-hover"
                :class="{'active-ceil-head': filerTableHead.selectedCeil === 1,
                    'hover-head-ceil': isExistInOptions(getCategoriesForSelect)}"
                @click.stop="showHideSubMenu(1)"
                @mouseover="addHoverElement(getCategoriesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 1}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Type</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-1"
                   v-show="filerTableHead.selectedCeil === 1"
                   tabindex="-1"
                   @click.stop="">
                <app-select
                        v-model="parent"
                        name="Category"
                        data-vv-as='"Category"'
                        :options="getCategoriesForSelect"
                        placeholder="Parent"/>
              </div>
            </th>
            <th class="categories-list-body__head_count-articles table-head-ceil">
              No of articles
            </th>
            <th colspan="2" class="cellpadding categories-list-body__head_actions table-head-ceil">Actions</th>
          </tr>
          </thead>
          <tbody class="categories-list-body__body">
          <tr v-for="(category, i) in updatedCategories">
            <td class="text-center cellpadding" v-if="category.type === 'show'">
              {{category.id}}
            </td>
            <td class="cellpadding" v-if="category.type === 'show'">
              {{category.isChild ? '- ' + category.title : category.title}}
            </td>
            <td class="cellpadding" v-if="category.type === 'show'">{{category.parent ? category.parent.label : '-'}}
            </td>
            <td class="cellpadding" v-if="category.type === 'show'">{{category.contents.length}}</td>
            <td class="cellpadding text-center" v-if="category.type === 'show'">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m edit-btn"
                      @click="showEditionForm(category.id)">
                <span class="table-tooltip">Edit</span>
              </button>
            </td>
            <td class="cellpadding text-center" v-if="category.type === 'show'">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m delete-btn"
                      @click="removeCategory(category.id)">
                <span class="table-tooltip">Delete</span>
              </button>
            </td>
            <td colspan="6" v-if="category.type === 'edit'" class="edit-row">
              <div class="wrap-edit-form">
                <div class="row-edit-form">
                  <div class="wrap-title-input">
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           placeholder="Title"
                           v-model="category.title">
                  </div>
                  <div class="wrap-parent-select">
                    <v-select
                            v-model="category.parent"
                            class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            name="Category"
                            :options="getCategoriesForSelect"
                            :searchable=false
                            placeholder="Parent"/>
                    <!--</div>-->
                  </div>
                  <div class="wrap-title-input">
                    <input type="text"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           placeholder="Icon"
                           v-model="category.icon">
                  </div>
                  <div class="wrap-desc-textarea">
                    <textarea name="desc-textarea"
                              cols="10" rows="1"
                              class="form-control form-control__textarea"
                              placeholder="Description"
                              v-model="category.description"></textarea>
                  </div>
                </div>
                <div class="wrap-table-control-panel">
                  <button type="button" @click="discardСhanges(category.id)">Cancel</button>
                  <button type="button" @click="editCategory(category.id)">Save</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/search'
import 'vue-awesome/icons/pencil'
import 'vue-awesome/icons/folder'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/chevron-up'
import 'vue-awesome/icons/chevron-down'
import AppSelect from '@/components/admin/common/Select'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'categories-list',
  data () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      categories: [],
      updatedCategories: [],
      contentAutoloadInfo: {
        curPage: 1,
        numPages: 1,
        locked: false
      },
      newCategory: {
        title: '',
        isActive: 1,
        description: '',
        parent: '',
        icon: ''
      },
      disableAPI: false,
      searchString: '',
      parent: null,
      statusbar: {
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false
    }
  },
  methods: {
    ...mapActions([
      'getCategories',
      'setInformationMsg',
      'clearConfAction',
      'initConfAction'
    ]),
    displayAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    closeAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    search () {
      if (!this.filter.search) {
        this.contentInfo.typeAutoLoad = 'allContent'
        this.fetchAllContentByScroll(1, 200)
        return
      }
      this.contentInfo.typeAutoLoad = 'searchContent'
      this.fetchSearchContent()
    },
    fetchSearchContent () {
      if (!this.filter.search) return
      let queryString = `${api.URLS.search}`
      Object.keys(this.filter).forEach((item) => {
        let value = this.filter[item]
        if (value && typeof (value) === 'string') {
          queryString += `&search=${value}`
        }
        if (value !== null && typeof (value) === 'object' && value.length) {
          let subString = ''
          value.forEach((it) => {
            subString += `&${item}=${it.value}`
          })
          queryString += subString
        }
      })
      if (this.contentType.length) queryString += '&contentType=' + this.contentType[0].value
      this.$http.get(`${queryString}`, api.headersAuthSettings)
        .then((res) => {
          let resData = res.body.data.items
          if (!resData) {
            this.articles = []
            return
          }
          this.articles = resData
        })
        .catch((err) => console.error(err))
    },
    removeCategory (id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeCategoryById'
      })
    },
    removeCategoryConfirmed (id) {
      let self = this
      let thisCategory = this.updatedCategories.find((category) => category.id === id)
      this.getCategories()
      this.$http.delete(api.URLS.category + '/' + id, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = thisCategory.title + ' category was successfully deleted.'
            self.infMsgDescription = 'Please note all actions are being logged.'
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            for (let i = 0; i < self.categories.length; i++) {
              if (self.categories[i].id === id) {
                self.categories.splice(i, 1)
                break
              }
            }
          })
          .catch((err) => console.log(err))
    },
    handleScroll (event) {
      let scrollHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight)
      let fullScrolledValue = window.pageYOffset + window.innerHeight

      if (fullScrolledValue > scrollHeight - 200) {
        this.fetchAllContentByScroll(++this.contentAutoloadInfo.curPage, 200)
      }
    },
    fetchAllContentByScroll (page, limit) {
      if (this.contentAutoloadInfo.locked || this.contentAutoloadInfo.curPage > this.contentAutoloadInfo.numPages) return
      this.contentAutoloadInfo.locked = true
      this.$http.get(api.URLS.categories1 + '?limit=' + limit + '&page=' + page, api.headersAuthSettings)
        .then((res) => {
          this.contentAutoloadInfo.curPage = res.body.current_page_number
          this.contentAutoloadInfo.numPages = Math.ceil(res.body.total_count / limit)
          this.categories = this.expendCategories(res.body.items.filter(item => !item.parent))
          this.contentAutoloadInfo.locked = false
        })
        .catch((err) => {
          this.contentAutoloadInfo.locked = false
          console.log(err)
        })
    },
    expendCategories (categories) {
      let result = []
      categories.forEach(item => {
        result.push(item)
        if (item.children.length) {
          item.children.forEach(child => {
            let curChild = child
            curChild.isChild = true
            curChild.parent = {
              label: item.title,
              value: item.id
            }
            result.push(curChild)
          })
        }
      })
      return result
    },
    createCategory () {
      if (this.disableAPI) return
      if (!this.newCategory.title) return
      let formData = new FormData()
      Object.keys(this.newCategory).forEach((fieldName) => {
        if (typeof this.newCategory[fieldName] === 'string' || typeof this.newCategory[fieldName] === 'number') {
          formData.append('category[' + fieldName + ']', this.newCategory[fieldName])
        }
        if (typeof this.newCategory[fieldName] === 'object' && fieldName !== 'parent') {
          this.newCategory[fieldName].forEach((item, i) => {
            formData.append('category[' + fieldName + '][' + i + ']', item.value)
          })
        }
      })
      if (this.newCategory.parent) {
        formData.append('category[parent]', this.newCategory.parent.value)
      }
      this.disableAPI = true
      this.$http.post(api.URLS.category, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = this.newCategory.title + ' category was successfully added.'
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.newCategory.title = ''
          this.newCategory.parent = null
          this.newCategory.description = ''
          this.newCategory.icon = ''
          this.addFormDisplay = false
          this.fetchAllContentByScroll(1, 200)
          this.getCategories
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    showEditionForm (id) {
      for (let category of this.updatedCategories) {
        if (category.type === 'edit') category.type = null
        if (category.id === id && category.type === null) {
          category.type = 'edit'
        }
      }
    },
    editCategory (id) {
      if (this.disableAPI) return
      let category = this.updatedCategories.find((category) => category.id === id && category.type === 'edit')
      let formData = {
        category: {
          title: category.title,
          description: category.description,
          icon: category.icon,
          isActive: 1
        }
      }
      if (category.parent && category.parent !== null) {
        formData.category.parent = category.parent.value
      }
      this.disableAPI = true
      this.$http.put(api.URLS.category + '/' + id, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.discardСhanges(id)
          this.fetchAllContentByScroll(1, 200)
          let infMsg = 'Category has been successfully updated'
          this.setInformationMsg({text: infMsg, className: 'success'})
        })
        .catch((err) => {
          this.disableAPI = false
          console.log(err)
        })
    },
    discardСhanges (id) {
      for (let category of this.updatedCategories) {
        if (category.id === id && category.type === 'edit') {
          category.type = null
        }
      }
    },
    removeSelectedFilters (filter) {
      this.parent = null
    },
    removeAllFilters () {
      this.parent = null
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    isExist (element) {
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    }
  },
  computed: {
    ...mapGetters([
      'getCategoriesTitle',
      'getCategoriesForSelect',
      'parentCategoriesForSelect',
      'getTagsForSelect',
      'getConfData'
    ]),
    filteredCategories () {
      return this.categories.filter((category) => category.title.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1)
        .filter((category) => this.parent === null || (category.parent && category.parent.value === this.parent.value))
    }
  },
  watch: {
    filteredCategories: function () {
      let updatedCategories = []
      this.filteredCategories.forEach((category, i, arr) => {
        category.type = 'show'
        updatedCategories.push(category)
        updatedCategories.push({
          type: null,
          id: category.id,
          title: category.title,
          parent: category.parent ? {label: category.parent.label, value: category.parent.value} : null,
          description: category.description,
          icon: category.icon
        })
      })
      this.updatedCategories = updatedCategories
    },
    'getConfData.actionConfirmed' (value) {
      let actionName = this.getConfData.actionName
      if (value) {
        switch (actionName) {
          case 'removeCategoryById':
            this.removeCategoryConfirmed(this.getConfData.actionId)
            this.clearConfAction()
            break
        }
      }
    }
  },
  components: {
    AppSelect
  },
  mounted () {
    this.fetchAllContentByScroll(1, 200)
    this.getCategories()
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  created () {
    document.title = 'Categories in "Topics" | Clear Assured'
    if (window._paq) {
      window._paq.push(['setCustomUrl', location.pathname])
      window._paq.push(['setDocumentTitle', document.title])
      window._paq.push(['trackPageView'])
    }
    // if (window.ga) {
    //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
    //   window.ga('send', 'pageview', {
    //     'page': location.pathname,
    //     'location': location.href,
    //     'title': document.title
    //   })
    // }
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />


//TODO: Use updated categories commit it for correct removing



// WEBPACK FOOTER //
// CategoriesList.vue?cfffeed8